/* This file is autogenerated, see readme.md for instructions */
import CopyToDashboardSvgIcon from '@bloomreach/banana-theme/icons/copy-to-dashboard.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const CopyToDashboardIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <CopyToDashboardSvgIcon />
    </Icon>
  );
});

CopyToDashboardIcon.displayName = 'CopyToDashboardIcon';

export default CopyToDashboardIcon;
